import { PrerequisiteRuleTypes, type ExtensionConfig } from '@goto/shell-common'
import { getFeatureFlag } from '../helpers/shell-helpers'

export const extensionConfig: ExtensionConfig = {
  id: '@goto/call-reports-widgets',
  esModule: true,
  get url() {
    const version = getFeatureFlag('call-reports-widgets-version', 'latest')
    return new URL(`/experiences/call-reports-widgets/${version}/call-reports-widgets-extension.js`, location.origin)
  },
  prerequisites: {[PrerequisiteRuleTypes.SHELL_FEATURE_FLAGS]: "insights.enable"},
  dependencies: ['@goto/shell-extensions-widgets'],
}

export default extensionConfig